import { getClassificationOtherCategory, ProductClass } from "@atlas-int/data";

const hs92OtherCategoryId = getClassificationOtherCategory(ProductClass.HS92Products);

export const removeOtherProducts = (product: Record<string, unknown>) => {
  /* NOTE: For market share, we specifically filter out `Other` products from the visualization */
  const { id, productId } = product;
  if (id) {
    return product.id !== hs92OtherCategoryId;
  } else if (productId) {
    return product.productId !== hs92OtherCategoryId;
  }
};
